<template lang="pug">
  include ./../../../mixins
  validation-provider(
    :name="$attrs.name"
    :rules="rules",
    :vid="$attrs.vid"
    v-slot="{ validate, errors }",
    tag="div"
  )
    +b.ds-control-box(
      :class="errors.length ? 'is-erors': '' "
    )
      +e.body(
        :class="value ? 'is-value': '' "
      )
        slot
          +b.INPUT.ds-control-input.--style_default.effect-line-input(
            :class="className"
            :value="value",
            :type="$attrs.type",
            ref='input',
            :disabled='$attrs.disabled',
            :placeholder="$attrs.placeholder",
            :id="$attrs.id",
            :min='$attrs.min',
            v-model="innerValue"
          )
          span.focus-border

</template>
<script>
export default {
  inheritAttrs: false,
  name: 'InputGroup',
  props: {
    isRequired: {
      default: false,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    value: {
      type: null,
    },
    className: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/InputGroup.vue